import Vue from "vue";
import Component from 'vue-class-component';

@Component
export default class GlobalMixin extends Vue {

    public isLg: boolean;
    public isAside: boolean;
    public isMd: boolean;
    public isSm: boolean;
    public isSmAuth: boolean;

    constructor() {
        super();

        this.isAside = false;
        this.isLg = false;
        this.isMd = false;
        this.isSm = false;
        this.isSmAuth = false;
    }

    mounted() {
        this.setBreakpoint();

        window.addEventListener("resize", () => {
            this.setBreakpoint();
        });
    }

    protected setBreakpoint(): void {
        this.setIsAside();
        this.setIsLg();
        this.setIsMd();
        this.setIsSm();
        this.setIsSmAuth();
    }

    protected setIsAside(): void {
        this.isAside = (window.innerWidth < 1200 && window.innerWidth > 560);
    }

    protected setIsLg(): void {
        this.isLg = (window.innerWidth <= 959);
    }

    protected setIsMd(): void {
        this.isMd = (window.innerWidth <= 768);
    }

    protected setIsSm(): void {
        this.isSm = (window.innerWidth <= 560);
    }

    protected setIsSmAuth(): void {
        this.isSmAuth = (window.innerWidth <= 630);
    }

}